import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetIndoorOversized extends AbstractProductType {

  name = 'valet_indoor_oversized'
  title = 'Valet Indoor Oversized'

  oversized = true
  valet = true

  format = ProductTypeFormat.Indoor

}
